import { Deserializable } from '../protocols/deserializable';
import { BeneficiaryChangeSubmissionData } from './beneficiary-change-submission-data';
import { AccountTypeIdEnum } from '../transactions/enum/account-type-id.enum';
import { MemberSubmissionAccount } from '../transactions/member-submission-account';

export class BeneficiaryChangeSubmission implements Deserializable {
  public affectedAccounts!: MemberSubmissionAccount[];
  public previous!: BeneficiaryChangeSubmissionData;
  public new!: BeneficiaryChangeSubmissionData;
  public accountTypeId!: AccountTypeIdEnum;
  public consentWaiverRequired!: boolean;

  public onDeserialize(): void {
    const Deserialize = window.injector.Deserialize;

    if (!!this.previous) {
      this.previous = Deserialize.instanceOf(BeneficiaryChangeSubmissionData, this.previous);
    }

    if (!!this.new) {
      this.new = Deserialize.instanceOf(BeneficiaryChangeSubmissionData, this.new);
    }

    if (this.affectedAccounts?.length) {
      this.affectedAccounts = Deserialize.arrayOf(MemberSubmissionAccount, this.affectedAccounts);
    }
  }
}
